import moment from 'moment';

export const dateOfBirthValueRenderer = ({ value }) => {
  if (value) {
    return moment.utc(value).format('MM/DD/YYYY');
  }
};
